import styled, {css} from 'styled-components';
import {ActionType} from './types';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  min-width: 316px;
  box-sizing: border-box;
  padding: 15px;
`;

export const Header = styled.div`
  margin-bottom: 12px;
`;

export const Title = styled.span`
  padding: 0 5px;
  font-weight: 500;
  font-size: 16px;
`;

export const Content = styled.div`
  
`;

export const Footer = styled.div`
  margin-top: 6px;
  justify-content: flex-end;
  display: flex;
`;

export const Button = styled.button<{
  actionType: ActionType;
}>`
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  
  ${({actionType, theme}) => {
    switch (actionType) {
      case ActionType.Submit: return css`
        color: ${theme.colors.primary};
      `;
      case ActionType.Reset: return css`
        color: ${transparentize(.6, theme.variables.color)};
      `;
    }
  }};
`;
